import { render } from "./ContactDialog.vue?vue&type=template&id=17dffcbb&scoped=true"
import script from "./ContactDialog.vue?vue&type=script&lang=js"
export * from "./ContactDialog.vue?vue&type=script&lang=js"

import "./ContactDialog.vue?vue&type=style&index=0&id=17dffcbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dffcbb"]])

export default __exports__